import React from "react";
import { IonItem } from "@ionic/react";

const Item: React.FC = ({ children }) => {
  return <IonItem style={{ paddingTop: "5px" }}>{children}</IonItem>;
};

export default Item;
